// src/pages/usa/colorado/Frisco.js
import "../../../App.css";
import Header from "../../../components/Header";
import Footer from "../../../components/Footer";

import BackOnly from "../../../components/BackOnly";
import ContactPopup from "../../../components/ContactPopup";
import React, { useState, useEffect } from "react";
import AffiliateBooking from "../../../components/affiliate/AffiliateBooking";
import AffiliateExpedia from "../../../components/affiliate/AffiliateExpedia";
import AffiliateTrip from "../../../components/affiliate/AffiliateTrip";

import { useNavigate } from "react-router-dom";   // ⭐ REQUIRED

// ⭐ STRICT COMMAND: Frisco ALWAYS goes back to Colorado map
export const backRoute = "/map/colorado";

export default function Frisco() {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  // ⭐ Send strict back command to BackOnly (NO LOOPS)
  useEffect(() => {
    if (!window.__friscoBackRouteSet) {
      window.__friscoBackRouteSet = true;
      navigate(".", { replace: true, state: { backRoute } });
    }
  }, [navigate]);

  return (

    <>
      <Header />

      <div className="visited-back-wrapper">
        <BackOnly />
      </div>


      <div className="page-container" style={{ padding: "12px" }}>
        <h1>Frisco, Colorado</h1>

        <section className="travel-review">
          {/* LEFT COLUMN — TEXT */}
          <div className="travel-text">
            <h2>🏞️ Discover Frisco, Colorado</h2>

            <p>
              Frisco is a small town nestled in the heart of Summit County — close to Breckenridge,
              Silverthorne, Dillon, and Copper Mountain. Its central location makes it a year‑round magnet
              for visitors seeking seasonal adventures. From summer through fall, Frisco offers scenic trails
              that wind through golden aspens and alpine meadows.
            </p>

            <p>
              In winter, while it doesn’t host a ski resort of its own, it sits just minutes from Copper
              Mountain and Breckenridge. For lighter winter fun, the Frisco Adventure Park features a tubing
              hill that delivers snowy thrills without the need for skis.
            </p>

            <h3>🚗 Getting There</h3>

            <p>
              The drive from Denver to Frisco takes about 1.5 hours, depending on traffic and weather.
              Traveling west on I‑70, you'll pass through stunning mountain scenery, with quick access to
              Silverthorne and Dillon just before reaching Frisco.
            </p>

            {/* 🌟 PERSONAL OBSERVATION */}
            <h3>🌟 My Personal Observation</h3>

            <ul>
              <li>
                <div className="place-block">
                  <strong>The Bike Path / Recpath Network:</strong> A connected system of scenic trails linking
                  Breckenridge, Frisco, Copper Mountain, Vail Pass, and Vail Village. I rode part of the Tenmile
                  Canyon Recpath — beautiful morning ride with gentle ups and downs.
                </div>
              </li>

              <li>
                <div className="place-block">
                  <strong>Walk the Town:</strong> Frisco’s Main Street is lined with restaurants, cafés, and rental
                  shops — perfect for breakfast or a relaxing stroll.
                </div>
              </li>
            </ul>

            {/* 🥾 HIDDEN GEMS */}
            <h3>🥾 Hidden Gems in Frisco</h3>

            <ul>
              <li>
                <div className="place-block">
                  <strong>Frisco Adventure Park:</strong> Tubing hill, beginner ski area, disc golf, and year‑round fun.<br />
                  <a
                    href="https://www.google.com/maps?q=39.574100601913216, -106.07766863360737"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    📍 View on Google Maps
                  </a>
                </div>
              </li>

              <li>
                <div className="place-block">
                  <strong>Rainbow Lake Trail:</strong> Short, peaceful hike to a small alpine lake — great for families.<br />
                  <a
                    href="https://www.google.com/maps?q=39.56935983282579, -106.09956599001843"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    📍 View on Google Maps
                  </a>
                </div>
              </li>

              <li>
                <div className="place-block">
                  <strong>Historic Park & Museum:</strong> Preserved mining‑era buildings and exhibits right on Main Street.<br />
                  <a
                    href="https://www.google.com/maps?q=39.57516615571851, -106.10054267394662"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    📍 View on Google Maps
                  </a>
                </div>
              </li>
            </ul>

            {/* 🛏️ PLACES TO STAY */}
            <h3>🛏️ Places to Stay in Frisco</h3>

            <p>
              Frisco offers a range of highly rated accommodations that combine comfort, location, and mountain charm.
            </p>

            <ul>
              <li>
                <div className="place-block">
                  <strong>Frisco Inn on Galena Street:</strong> Rated 9.8/10 on Expedia and 9.3/10 on Booking.com.
                </div>
              </li>

              <li>
                <div className="place-block">
                  <strong>Frisco Lodge:</strong> Historic charm, homemade breakfast, wine tastings, hot tub courtyard.
                </div>
              </li>

              <li>
                <div className="place-block">
                  <strong>AC Hotel Frisco Colorado:</strong> Modern, mountain views, great for ski trips.
                </div>
              </li>

              <li>
                <div className="place-block">
                  <strong>Hotel Frisco:</strong> Centrally located, walkable, warm rooms.
                </div>
              </li>

              <li>
                <div className="place-block">
                  <strong>Snowshoe Motel:</strong> Budget‑friendly, clean, close to everything.
                </div>
              </li>
            </ul>

            {/* AFFILIATE BLOCK */}
           <h3>If you are looking for a place to stay, you can check prices, date and time here.</h3>
                       <div className="affiliate-block">
                         <AffiliateExpedia />
                         <AffiliateBooking />
                         <AffiliateTrip />
                       </div>
            {/* 🎥 VIDEOS */}
            <h3>🎥 My Travel Videos</h3>

            <p>Here are some videos from Frisco.</p>

            <p>
              <a
                href="https://youtu.be/0dmnRYbqcnc?si=zruJfWS3rJ7eGDO3"
                target="_blank"
                rel="noopener noreferrer"
              >
                Tenmile Canyon Recpath
              </a>
              <br />
              <a
                href="https://youtu.be/9gRMhRVv5ng?si=ZUOG3EwhhbL_ySGj"
                target="_blank"
                rel="noopener noreferrer"
              >
                Frisco Town
              </a>
            </p>
          </div>

          {/* RIGHT COLUMN — IMAGES */}
          <div className="travel-image-column">
            <a
              href="https://youtu.be/9gRMhRVv5ng?si=ZUOG3EwhhbL_ySGj"
              target="_blank"
              rel="noopener noreferrer"
              className="youtube-image-card"
            >
              <img
                src="/images/usa/colorado/frisco/frisco.jpg"
                alt="Frisco Town"
              />
            </a>

            <a
              href="https://youtu.be/0dmnRYbqcnc?si=zruJfWS3rJ7eGDO3"
              target="_blank"
              rel="noopener noreferrer"
              className="youtube-image-card"
            >
              <img
                src="/images/usa/colorado/frisco/shelter.jpg"
                alt="Tenmile Canyon Recpath Video"
              />
            </a>

            <img src="/images/usa/colorado/frisco/mountainview.jpg" alt="Mountain View" />
            <img src="/images/usa/colorado/frisco/butter.jpg" alt="View of the Street" />
            <img src="/images/usa/colorado/frisco/restaurant.jpg" alt="Another Street View" />
            <img src="/images/usa/colorado/frisco/viewofcooper.jpg" alt="View of Cooper Mountain" />
            <img src="/images/usa/colorado/frisco/shop.jpg" alt="Shop" />
            <img src="/images/usa/colorado/frisco/mountains.jpg" alt="The Mountains from town" />
            <img src="/images/usa/colorado/frisco/tenmilestraillake.jpg" alt="Lake in the TenMiles" />
            <img src="/images/usa/colorado/frisco/themountain.jpg" alt="Fall in the TenMiles" />
            <img src="/images/usa/colorado/frisco/thefallintrail.jpg" alt="Fall in the Trail" />
            <img src="/images/usa/colorado/frisco/viewofdillonlake.jpg" alt="View of Dillon Lake" />
          </div>
        </section>
      </div>

      {/* EMAIL BUTTON */}
      <div className="email-wrapper">
        <button className="email-link" onClick={() => setOpen(true)}>
          contact@thefindingspot.com
        </button>
      </div>

      <ContactPopup isOpen={open} onClose={() => setOpen(false)} />

      <Footer />
    </>
  );
}
